import React, { useCallback, useMemo, useState } from 'react';
import * as yup from 'yup';
import Button from '@mui/material/Button';
import Form from '@/common/components/Form/index';
import { TextInput } from '@/common/components/Inputs/index';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const VALIDATION = yup.object({
  email: yup.string().email('Must be valid email address').required(),
  password: yup.string().trim().required(),
});

const UserLogin = ({
  onSubmit = () => {},
  className,
  isPending = false,
  children,
}) => {
  const { t } = useTranslation();
  const { search } = useLocation();
  const [errors, setErrors] = useState([]);
  const error400 = useMemo(
    () => [
      [
        'email',
        {
          type: 'custom',
          message: t('Provided email or password are incorrect'),
        },
      ],
      [
        'password',
        {
          type: 'custom',
          message: t('Provided email or password are incorrect'),
        },
      ],
    ],
    [t]
  );
  // Use URLSearchParams, but preserve '+' (otherwise it is decoded as a space)
  const queryParams = useMemo(
    () => new URLSearchParams(search.replace(/\+/g, '%2B')),
    [search]
  );

  const tempPassword = queryParams.get('temp_pass');

  const handleSubmit = useCallback(
    async (form) => {
      setErrors([]);
      try {
        await onSubmit(form, (nextErrors) => {
          setErrors(nextErrors);
        });
      } catch (e) {
        setErrors(error400);
      }
    },
    [error400, onSubmit]
  );

  const initialValues = useMemo(
    () => ({
      email: queryParams.get('m') || '',
      password: queryParams.get('p') || '',
    }),
    [queryParams]
  );

  return (
    <Form
      initialValues={initialValues}
      validation={VALIDATION}
      className={className}
      onSubmit={handleSubmit}
      errors={errors}
    >
      <TextInput
        name="email"
        label={t('Email')}
        inputProps={{ maxLength: 50 }}
        sx={{ mb: 4 }}
      />
      <TextInput
        name="password"
        label={tempPassword ? t('Temporary password') : t('Password')}
        type="password"
        tip={
          tempPassword
            ? t('You can find the temporary password in your invitation email')
            : ''
        }
        inputProps={{ maxLength: 50 }}
      />
      {children}
      <Button
        type="submit"
        variant="contained"
        loading={isPending}
        fullWidth
        size="large"
        sx={{ mt: 5 }}
      >
        {t('Log in')}
      </Button>
    </Form>
  );
};

export default UserLogin;
